import React, { forwardRef } from 'react';

import { Control, Tooltip } from '@vlabs/uikit';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { viewerCan } from '@vlabs/pages/auth/selectors';

const LinkButtonWithPermissionsComponent = forwardRef(({
  permissions,
  disabled,
  can,
  as = 'a',
  ...props
}, externalRef) => {
  const { rules = [], method = 'oneof' } = permissions;

  const hasPermission = rules.length ? can(rules, { method }) : true;
  const isDisabled = !hasPermission || disabled;

  return (
    <Tooltip
      data-tooltip-content={!hasPermission ? i18n.t('кнопка.недостаточно прав.title') : null}
    >
      <Control.IconButton
        as={!isDisabled ? as : null}
        disabled={isDisabled}
        ref={externalRef}
        {...props}
      />
    </Tooltip>
  );
});

LinkButtonWithPermissionsComponent.propTypes = {
  permissions: PropTypes.shape({
    rules: PropTypes.arrayOf(PropTypes.string).isRequired,
    method: PropTypes.oneOf(['oneof', 'allof']),
  }),
  variant: PropTypes.oneOf([
    'filled',
    'flat',
    'outlined',
    'dimmed',
  ]),
  kind: PropTypes.oneOf([
    'primary',
    'secondary',
    'attention',
    'positive',
    'negative',
  ]),
  round: PropTypes.bool,
  className: PropTypes.string,
  can: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.element,
  as: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.node,
  size: PropTypes.oneOf(['small', 'medium']),
};

LinkButtonWithPermissionsComponent.defaultProps = {
  permissions: { rules: [], method: 'oneof' },
  kind: 'secondary',
  variant: 'outlined',
  round: false,
  className: undefined,
  disabled: false,
  title: '',
  icon: null,
  as: 'a',
  children: undefined,
  size: 'medium',
};

export const LinkButtonWithPermissions = connect((state) => ({
  can: viewerCan(state),
}))(LinkButtonWithPermissionsComponent);
